import { BRAND, THEME } from '../globals/typings';

export function getThemeForBrand(brand: string, subBrand?: string): THEME {
  switch (brand) {
    case BRAND.VW:
      return THEME.VW22;
    case BRAND.LNF:
      return THEME.LNF22;
    case BRAND.AUDI:
      return THEME.AUDI23;
    case BRAND.SEAT:
      if (subBrand === 'SC')
        return THEME.CUPRA24;
      return THEME.SEAT24;
    case BRAND.SKODA:
      return THEME.SKODA23;
  }
}

export function getCountryCodeFromLocale(locale: string): string {
  if (!locale) {
    throw new Error(`Invalid locale set! ("${locale}")`);
  }
  const localeArray = locale.split('_');
  if (localeArray.length !== 2) {
    throw new Error(`Invalid locale set! ("${locale}")`);
  }
  return localeArray[1];
}
